import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import classNames from 'classnames';

import COMMUNICATION_SIDEBAR_DATA from 'data/communicationSidebarData';
import ElementSpacePlaceholder from 'components/ElementSpacePlaceholder';
import NavBar from 'components/NavBar';
import styles from './CommunicationSidebar.module.scss';
import WithPermissions from 'components/WithPermissions';

export default function CommunicationSidebar() {
  return (
    <>
      <NavBar
        title="COMMUNICATION MANAGEMENT TOOL"
        className="p-xs"
        id="communication-sidebar"
      />
      <ElementSpacePlaceholder elementId="communication-sidebar" />
      <div className={styles.root}>
        {COMMUNICATION_SIDEBAR_DATA.map((data, sectionIndex) => (
          <div
            className={styles.section}
            key={`comms-sidebar-${sectionIndex}`}
          >
            <div
              className={classNames('bold', 'dark', styles.header)}
              key={sectionIndex}
            >
              {data.header}
            </div>
            <div className={styles.tabs}>
              {data.tabs.map((tab, tabIndex) => (
                <WithPermissions
                  key={`communication-tabs-${tabIndex}`}
                  subject={tab.subject}
                  permissions={tab.permissions}
                >
                  <NavLink
                    to={tab.to}
                    tabIndex={tabIndex}
                    className={({ isActive }) =>
                      classNames(styles.tab, { [styles.tabActive]: isActive })
                    }
                  >
                    {tab.tabName}
                  </NavLink>
                </WithPermissions>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className={styles.page}>
        <Outlet />
      </div>
    </>
  );
}
